// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1bjtC","label":"Category_label__22dTd","content":"Category_content__1US8X","header":"Category_header__2gt_H","location":"Category_location__15H7Y"};